import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as SecurityActions from '../_actions/security';
import { Security } from '../_models/security';

export interface SecurityState extends EntityState<Security> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Security> = createEntityAdapter<Security>();

const initialState: SecurityState = adapter.getInitialState({
  loading: false,
  error: null,
});

const securityReducer = createReducer(
  initialState,

  on(SecurityActions.loadSecurities, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(SecurityActions.loadSecuritiesSuccess, (state, { securities }) =>
    adapter.setAll(securities, { ...state, loading: false })
  ),

  on(SecurityActions.loadSecuritiesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(SecurityActions.addSecuritySuccess, (state, { security }) => adapter.addOne(security, state)),

  on(SecurityActions.updateSecuritySuccess, (state, { security }) =>
    adapter.upsertOne(security, state)
  ),

  on(SecurityActions.deleteSecuritySuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    SecurityActions.addSecurityFailure,
    SecurityActions.updateSecurityFailure,
    SecurityActions.deleteSecurityFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: SecurityState | undefined, action: Action) {
  return securityReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
